// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__iMr2i","wordmark":"Nav_wordmark__vziVC","links":"Nav_links__MwC2F","navLink":"Nav_navLink__EQKT9","cvButton":"Nav_cvButton__OE2rU"};